import React, { useState,useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { getModuleConfiguration } from "../../../store/Checkin/moduleConfigurationSlice";
import { initReactI18next, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";

import {CONFIG_MASTER_ENUM,STEP_MASTER_ENUM} from "../../../constants/constant";
import {getConfigurationCode,getStepMaster} from "../../../helpers/commonHelper";
const ConfirmAdultCountModal = ({
  showConfirmModal,
  confirmAdultCount,
  closeModal,
  closeAdultModal,
  adultCount,
  childCount
}) => {
  const { t } = useTranslation();
 
  const [selectedAdultCount, setSelectedAdultCount] = useState(adultCount);
  const [selectedChildCount, setSelectedChildCount] = useState(childCount);
  const [isFocused, setIsFocused] = useState(false);
    const stepMaster = useSelector((state) => getModuleConfiguration(state));
  
    const stepReservationPage = getStepMaster(
      stepMaster,
      STEP_MASTER_ENUM.HOME_PAGE
    );
    const configs = stepReservationPage?.configs;
  const adultChildCountChangeRequired = getConfigurationCode(
    configs,
    CONFIG_MASTER_ENUM.CHILDCOUNT_CHANGE_REQUIRED
  )?? false;
  

  const handleSelectChange = (event) => {
    const selectedValue = parseInt(event.target.value);
    //setSelectedAdultCount(Math.min(selectedValue, 3)); // Limiting to maximum of 3
    setSelectedAdultCount(Math.min(selectedValue)); //modified to set it based on adultcount
   
  };
  const handleAdultSelectChange = (event) => {
    const selectedValue = parseInt(event.target.value);
  
    setSelectedAdultCount(selectedValue);
    // If adult count is 3, set child count to 0 and disable its dropdown
    if (selectedValue === 3) {
      setSelectedChildCount(0);
    }
  };
  const handleChildSelectChange = (event) => {
    const selectedValue = parseInt(event.target.value);
  
    setSelectedChildCount(Math.min(selectedValue)); 
  };
  useEffect(() => {
    localStorage.setItem("selectedAdultCount", selectedAdultCount.toString());
  }, [selectedAdultCount]);
  useEffect(() => {
    localStorage.setItem("selectedChildCount", selectedChildCount.toString());
  }, [selectedChildCount]);
  return (
    <div>
      <Modal open={showConfirmModal} style={{ zIndex: "1" }}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "800px",
            backgroundColor: "#f5f5f5",
            border: "2px #000",
            boxShadow: "0 0 24px rgba(0, 0, 0, 0.5)",
            padding: "70px",
            borderRadius: "20px",
          }}
        >
          
          <button id="btn-adultchildcount-close" className="close-icon" onClick={closeAdultModal}
    style={{position: "absolute",top: "18px",right: "16px",border: "none",cursor: "pointer",}}
  >
    <CloseIcon style={{ color: "white", fontSize: "24px" }} />
  </button>
        {adultChildCountChangeRequired === true ? (
        <>
               <Typography
            id="modal-modal-description"  className="custom-font"
            sx={{ mt: 2, textAlign: "center", fontSize: "1.8rem" }}
          >
            <p>{t("Would you like to change Guest Count")+"?"}</p>
          </Typography>

          <div style={{ textAlign: "center" }}>
                      <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: "20px",
                }}
              >
               {/* Label for Adult Count */}
              <label
                htmlFor="adultCountDropdown"
                style={{ display: "block", marginBottom: "8px", marginRight: "8px",fontSize: "1.2rem" }}
              >
                {t("Adult Count : ")}
              </label>
              {/* Adult Count Dropdown */}
              <select
               /* value={selectedAdultCount_Guest}*/
                value={selectedAdultCount}
                onChange={handleAdultSelectChange}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                style={{
                  padding: "10px",
                  width: "100px",
                  border: isFocused ? "2px solid #007bff" : "2px solid #ced4da",
                  outline: "none",
                  borderRadius: "5px",
                  transition: "border-color 0.2s ease",
                  marginRight: "20px",
                }}
              >
                {Array.from({ length: 3 }, (_, i) => i + 1).map((count) => (
                  <option key={count} value={count}>
                    {count}
                  </option>
                ))}
              </select>
            
              
                 {/* Label for Child Count */}
                <label
                  htmlFor="childCountDropdown"
                  style={{ display: "block", marginBottom: "8px", marginRight: "8px",fontSize: "1.2rem" }}
                >
                  {t("Child Count : ")}
                </label>
              {/* Child Count Dropdown */}
                              <select
                  value={selectedChildCount}
                  onChange={handleChildSelectChange}
                  onFocus={() => setIsFocused(true)}
                  onBlur={() => setIsFocused(false)}
                  style={{
                    padding: "10px",
                    width: "100px",
                    border: isFocused ? "2px solid #007bff" : "2px solid #ced4da",
                    outline: "none",
                    borderRadius: "5px",
                    transition: "border-color 0.2s ease",
                  }}
                  disabled={selectedAdultCount === 3} // Disable when adult count is 3
                >
                  {Array.from({ length: 3 }, (_, i) => i).map((count) => (
                    <option key={count} value={count}>
                      {count}
                    </option>
                  ))}
                </select>
            </div>

         
             <div style={{ marginBottom: "20px" ,  marginTop: "50px"}}>
                <button id="btn-adultchildcount-yes"
                style={{ marginTop: "20px", padding: "15px", marginLeft: "15px" }}
                className="btn button-blue scan-btn"
                onClick={() => {
                    confirmAdultCount(selectedAdultCount,selectedChildCount);
                }}
                >
                {t("Yes")}
                </button>

                <button id="btn-adultchildcount-no"
                style={{ marginTop: "20px", padding: "15px", marginLeft: "15px" }}
                className="btn button-blue scan-btn"
                onClick={() => {
                    closeModal();
                    confirmAdultCount(adultCount,childCount);
                }}
                >
                {t("No")}
                </button>
            </div>
          </div>         
        </> 
        ):(
          <>

          <Typography
            id="modal-modal-description" 
            sx={{ mt: 2, textAlign: "center", fontSize: "1.8rem" }}
          >
            <p>{t("Would you like to change Adult Count")+"?"}</p>
          </Typography>

          <div style={{ textAlign: "center" }}>
            <div style={{ marginBottom: "20px" }}>
            <select
              value={selectedAdultCount}
              onChange={handleSelectChange}
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              style={{
                padding: "10px",
                width: "100px", // Adjust width as needed
                border: isFocused ? "2px solid #007bff" : "2px solid #ced4da", // Highlight border color
                outline: "none", // Remove default focus outline
                borderRadius: "5px", // Rounded corners
                transition: "border-color 0.2s ease", // Smooth transition
              }}
            >
                {/* {[1, 2, 3].map((count) => (
                    <option key={count} value={count} selected={selectedAdultCount}>
                    {count}
                    </option>
                ))} */}
                 {Array.from({ length: adultCount }, (_, i) => i + 1).map((count) => (
                  <option key={count} value={count}>
                    {count}
                  </option>
                ))}
                </select>
            </div>

            <div style={{ marginBottom: "20px" ,  marginTop: "50px"}}>
                <button id="btn-adultcount-yes"
                style={{ marginTop: "20px", padding: "15px", marginLeft: "15px" }}
                className="btn button-blue scan-btn"
                onClick={() => {
                    confirmAdultCount(selectedAdultCount,0);
                }}
                >
                {t("Yes")}
                </button>

                <button id="btn-adultcount-no"
                style={{ marginTop: "20px", padding: "15px", marginLeft: "15px" }}
                className="btn button-blue scan-btn"
                onClick={() => {
                    closeModal();
                }}
                >
                {t("No")}
                </button>
            </div>
          </div>
          </> 
        )}
        </Box>
      </Modal>
    </div>
  );
};

export default ConfirmAdultCountModal;
